import { z } from 'zod';

// Firebase timestamp schema (mirrors unitSchema.js)
const FirebaseTimestampSchema = z.object({
  seconds: z.number(),
  nanoseconds: z.number()
});

// Main device schema — validates docs from the Firestore `devices` collection.
// Written by Osiris' DeviceClass (deviceType, totalUsage, unitID) and, separately,
// by provisioning tooling (deviceID, installationDate). Kept non-strict since the
// full real-world shape spans more than one writer.
export const DeviceSchema = z.object({
  deviceID: z.string().optional(),
  deviceType: z.string().optional(),
  totalUsage: z.number().optional(),
  unitID: z.string().optional(),
  // Provisioning writes 0 for devices that were never installed
  installationDate: z.union([FirebaseTimestampSchema, z.number()]).optional()
}).passthrough();

// Type inference
export type Device = z.infer<typeof DeviceSchema>;

/**
 * Validates if an object matches the Device schema
 * @param {any} device - The device object to validate
 * @returns {boolean} - True if the device is valid
 */
export const validateDevice = (device) => {
  try {
    DeviceSchema.parse(device);
    return true;
  } catch (error) {
    console.group('🚨 Device Validation Failed');
    console.log('Device data:', device);
    console.log('Validation errors:', error.issues || error.errors);
    console.groupEnd();
    return false;
  }
};
